export const defaults = {
  el: document.querySelector('.marquee'),
  direction: 'left',
  duration: 5,
  css: true,
  disableResize: false
}
